'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'image-polaroid';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8c4';
var svgPathData = 'M416 384l0 64L32 448l0-64 384 0zM105.4 352L32 352l0-9.4 96-96L169.4 288l-60.7 60.7-3.3 3.3zm45.3 0l52.7-52.7L288 214.6l128 128 0 9.4-265.4 0zM416 297.4L299.3 180.7 288 169.4l-11.3 11.3L192 265.4l-52.7-52.7L128 201.4l-11.3 11.3L32 297.4 32 64l384 0 0 233.4zM448 336l0-272 0-32-32 0L32 32 0 32 0 64 0 336s0 0 0 0l0 16 0 16 0 16 0 64 0 32 32 0 384 0 32 0 0-32 0-64 0-16 0-16 0-16s0 0 0 0zM128 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImagePolaroid = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;